import React from 'react';

function SortDown(props: object) {
  return (
    <svg
      width="18"
      height="10"
      viewBox="0 0 18 10"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
    >
      <path
        d="M14.875 1.25L8 8.125L1.125 1.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SortDown;
